// src/styles/KnowledgeStyles.js
import styled from 'styled-components';
import { Card } from '../main/CommonStyles';
import { StyledButton } from '../main/CommonStyles';

export const KnowledgeBaseGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr; // Domyślnie jedna kolumna na mobilkach
    gap: ${({ theme }) => theme.spacing.md}; // Mniejszy odstęp na mobilkach
    margin-top: ${({ theme }) => theme.spacing.md};

    @media (min-width: 600px) {
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: ${({ theme }) => theme.spacing.lg};
    }
`;

export const ArticleCardStyled = styled(Card)`
    display: flex;
    flex-direction: column;
    cursor: pointer; // Cała karta jest klikalna
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    padding: 0; // Usuwamy domyślny padding Card, będziemy zarządzać nim wewnątrz

    &:hover {
        transform: translateY(-5px);
        box-shadow: ${({ theme }) => theme.shadows.xl};
    }

    .article-card-image { // Style dla obrazka w karcie
        width: 100%;
        height: 180px; // Stała wysokość obrazka w karcie
        object-fit: cover; // Obrazek będzie przycięty, aby wypełnić przestrzeń
        border-radius: ${({ theme }) => theme.borderRadius} ${({ theme }) => theme.borderRadius} 0 0; // Zaokrąglenie tylko górnych rogów
    }

    .article-image-placeholder {
        height: 180px;
        background-color: ${({ theme }) => theme.colors.neutralLight};
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({ theme }) => theme.colors.textDisabled};
        font-style: italic;
        font-size: 0.875rem;
        border-radius: ${({ theme }) => theme.borderRadius} ${({ theme }) => theme.borderRadius} 0 0;
    }

    .article-card-content { // Kontener na tekst w karcie
        padding: ${({ theme }) => theme.spacing.md}; // Padding dla tekstu
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .article-category {
        font-size: 0.75rem; // Mniejsza czcionka dla kategorii
        font-weight: 600;
        color: ${({ theme }) => theme.colors.secondary};
        margin-bottom: ${({ theme }) => theme.spacing.xs};
        text-transform: uppercase;
    }

    h3 {
        font-size: 1.1rem; // Mniejszy tytuł na karcie
        font-weight: 700;
        color: ${({ theme }) => theme.colors.primaryDarker};
        margin-bottom: ${({ theme }) => theme.spacing.sm};
        line-height: 1.3;
    }

    .article-snippet {
        font-size: 0.875rem; // Mniejszy snippet
        color: ${({ theme }) => theme.colors.textMedium};
        margin-bottom: ${({ theme }) => theme.spacing.md};
        line-height: 1.5; // Nieco mniejsza interlinia dla snippetu
        flex-grow: 1;
    }
`;

// Przycisk ReadMoreButton pozostaje, ale jest używany tylko do powrotu
export const ReadMoreButton = styled(StyledButton)`
    // Style dla przycisku "Wróć do listy" - mogą być tutaj lub w komponencie
`;

export const FullArticleWrapper = styled.div`
    padding: ${({ theme }) => theme.spacing.sm} 0; // Mniejszy padding, lub tylko góra/dół
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: ${({ theme }) => theme.borderRadius};
    // box-shadow: ${({ theme }) => theme.shadows.md}; // Można usunąć cień dla pełnego artykułu
    margin-top: ${({ theme }) => theme.spacing.sm};

    .article-image-full { // Style dla obrazka w pełnym artykule
        width: 100%;
        max-height: 300px; // Ograniczenie wysokości obrazka
        object-fit: cover;
        border-radius: ${({ theme }) => theme.borderRadius};
        margin-bottom: ${({ theme }) => theme.spacing.lg}; // Odstęp pod obrazkiem
        display: block; // Aby marginesy działały poprawnie
    }
    
    h2 { 
        font-size: 1.5rem; // Mniejszy główny tytuł artykułu na mobilkach
        font-weight: 700;
        color: ${({ theme }) => theme.colors.primaryDarker};
        margin-bottom: ${({ theme }) => theme.spacing.sm};
        line-height: 1.3;
        @media (min-width: 768px) {
            font-size: 1.85rem;
        }
    }

    .article-meta {
        font-size: 0.8rem; // Mniejsza czcionka dla metadanych
        color: ${({ theme }) => theme.colors.textMedium};
        margin-bottom: ${({ theme }) => theme.spacing.md}; // Mniejszy margines
        
        span {
            margin-right: ${({ theme }) => theme.spacing.md};
        }
    }

    .article-content {
        font-size: 0.9375rem; // Trochę mniejsza czcionka (15px jeśli baza to 16px)
        line-height: 1.7; // Zwiększona interlinia dla czytelności
        color: ${({ theme }) => theme.colors.textDark};

        p {
            margin-bottom: ${({ theme }) => theme.spacing.md}; // Odstęp między akapitami
        }

        h3 { // Podtytuły w artykule
            font-size: 1.25rem; // Mniejsze podtytuły
            font-weight: 600;
            color: ${({ theme }) => theme.colors.primaryDark};
            margin-top: ${({ theme }) => theme.spacing.lg};
            margin-bottom: ${({ theme }) => theme.spacing.xs};
            line-height: 1.4;
        }

        ul, ol {
            margin-bottom: ${({ theme }) => theme.spacing.md};
            padding-left: ${({ theme }) => theme.spacing.lg}; // Standardowy wcięcie listy
        }

        li {
            margin-bottom: ${({ theme }) => theme.spacing.xs}; // Mniejszy odstęp między elementami listy
            padding-left: ${({ theme }) => theme.spacing.xs}; // Mały padding dla elementów listy
        }

        strong {
            font-weight: 600;
            color: ${({ theme }) => theme.colors.textDark}; // Dla lepszego kontrastu
        }

        em {
            font-style: italic;
            color: ${({ theme }) => theme.colors.textMedium};
        }

        blockquote {
            border-left: 3px solid ${({ theme }) => theme.colors.primary}; // Cieńsza linia cytatu
            padding-left: ${({ theme }) => theme.spacing.md};
            margin: ${({ theme }) => theme.spacing.lg} 0; // Większy margines wokół cytatu
            font-style: italic;
            color: ${({ theme }) => theme.colors.textMedium};
            font-size: 0.9rem; // Mniejsza czcionka cytatu
            p { // Dla akapitów wewnątrz cytatu
                margin-bottom: ${({ theme }) => theme.spacing.sm};
            }
        }

        // Style dla urządzeń mobilnych - można dodać bardziej szczegółowe
        @media (max-width: 768px) {
            font-size: 0.875rem; // Jeszcze mniejsza czcionka na mobilkach (14px)
            line-height: 1.65;

            h2 {
                font-size: 1.3rem;
            }
            h3 {
                font-size: 1.1rem;
            }
            blockquote {
                font-size: 0.85rem;
            }
        }
    }
`;